import { createRoot } from "react-dom/client";
import { useCallback, useEffect, useState } from "react";
import "@fontsource-variable/newsreader/opsz.css";
import "@fontsource-variable/newsreader/opsz-italic.css";
import "@fontsource-variable/instrument-sans/index.css";
import "@fontsource/dm-mono/400.css";
import "@fontsource/dm-mono/500.css";
import { fetchMe, type MeInfo } from "./lib/client.ts";
import { Dashboard } from "./views/Dashboard.tsx";
import { Room } from "./views/Room.tsx";
import { CardView } from "./views/Card.tsx";
import { Protocol } from "./views/Protocol.tsx";

export type Nav = (path: string) => void;

function App() {
  const [path, setPath] = useState(location.pathname);
  const [me, setMe] = useState<MeInfo | null | undefined>(undefined);

  useEffect(() => { void fetchMe().then(setMe); }, []);
  useEffect(() => {
    const on = () => setPath(location.pathname);
    addEventListener("popstate", on);
    return () => removeEventListener("popstate", on);
  }, []);
  const nav = useCallback<Nav>((p) => { history.pushState(null, "", p); setPath(p); scrollTo(0, 0); }, []);

  if (me === undefined) return null;
  if (me === null) {
    return (
      <main className="gate">
        <p className="eyebrow">Mindsight Lab</p>
        <h1 className="gate-title">This lab is private.</h1>
        <p className="gate-body">Open your personal invite link to come in.</p>
      </main>
    );
  }
  if (path === "/card") return <CardView />;

  return (
    <div className="shell">
      {me.demo && <div className="demo-banner">Demo data, simulated. Not a real result.</div>}
      <header className="topbar">
        <a className="brand" href="/" onClick={(e) => { e.preventDefault(); nav("/"); }}>
          <span className="brand-mark" aria-hidden />Mindsight Lab
        </a>
        <nav className="tabs">
          {[["/", "Results"], ["/room", "Session"], ["/protocol", "Protocol"]].map(([p, label]) => (
            <a key={p} href={p} className={path === p ? "tab on" : "tab"} onClick={(e) => { e.preventDefault(); nav(p!); }}>{label}</a>
          ))}
        </nav>
        <span className="who">{me.name}</span>
      </header>
      {path === "/room" ? <Room me={me} /> : path === "/protocol" ? <Protocol me={me} /> : <Dashboard me={me} nav={nav} />}
    </div>
  );
}

createRoot(document.getElementById("root")!).render(<App />);
